import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    names: 'Sarah & Michael',
    location: 'Charlotte, NC',
    text: 'Our ceremony was absolutely perfect. The personalized vows and the warmth brought to our special day made it unforgettable.',
    rating: 5,
  },
  {
    id: 2,
    names: 'James & David',
    location: 'Raleigh, NC',
    text: 'We felt truly seen and celebrated. The ceremony honored our journey beautifully and our guests were moved to tears.',
    rating: 5,
  },
  {
    id: 3,
    names: 'Emily & Robert',
    location: 'Asheville, NC',
    text: 'From the first meeting to our wedding day, we felt supported and understood. Our ceremony was everything we dreamed of.',
    rating: 5,
  },
];

const Testimonials = () => {
  return (
    <section className="section-container">
      {/* Section Header */}
      <div className="text-center mb-16">
        <p className="text-gold-500 tracking-[0.3em] uppercase text-sm mb-4">
          Love Stories
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-warm-100 mb-6">
          Words from Happy Couples
        </h2>
        <div className="divider-gold max-w-xs mx-auto" />
      </div>

      {/* Testimonials Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {testimonials.map((testimonial, index) => (
          <div
            key={testimonial.id}
            className="card-elegant p-8 relative animate-fade-in"
            style={{ animationDelay: `${index * 0.15}s` }}
            data-testid={`testimonial-${testimonial.id}`}
          >
            {/* Quote Icon */}
            <Quote className="w-10 h-10 text-gold-500/30 absolute top-6 right-6" />

            {/* Stars */}
            <div className="flex space-x-1 mb-6">
              {[...Array(testimonial.rating)].map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4 text-gold-500"
                  fill="currentColor"
                />
              ))}
            </div>

            {/* Quote */}
            <p className="text-warm-100/80 italic leading-relaxed mb-6">
              "{testimonial.text}"
            </p>

            {/* Attribution */}
            <div className="border-t border-gold-500/20 pt-4">
              <p className="text-warm-100 font-serif text-lg">
                {testimonial.names}
              </p>
              <p className="text-warm-100/50 text-sm">
                {testimonial.location}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div className="text-center mt-16">
        <Link
          to="/gallery"
          className="btn-gold-outline text-sm tracking-[0.2em] uppercase"
          data-testid="view-gallery-btn"
        >
          View Gallery & More Stories
        </Link>
      </div>
    </section>
  );
};

export default Testimonials;
